const Ls7PrevencionVSR = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                    <h1 className='titulo--lesson--color--1'>¿C&oacute;mo prevenir la transmisi&oacute;n del <span className='titulo--lesson--color--2'>VSR </span> y dem&aacute;s <span className='titulo--lesson--color--2'>virus respiratorios? </span></h1>

                    <h1 className="text--subtitulo p-4">L&aacute;vese frecuentemente las manos</h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls7LavarManos.png" className='ps-2' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'>Utilice agua y jab&oacute;n durante al menos 20 segundos, <span className="texto--span">en especial antes de entrar en contacto con personas susceptibles como beb&eacute;s prematuros.</span> Advierta a toda su familia sobre este punto.</p>
                            </div>
                        </div>
                    </div>

                    <div className='col d-block d-sm-block d-md-none style--gif-2 background--baby'>
                        <img src="./img/Ls7Baby.gif" className='img--gid-2' />
                        {/* ./img/Ls1Background.png */}
                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>VSR: virus sincitial respiratorio. <br />
                            Adaptado de: <a className='texto--link' target='_blank' href='http://www.cdc.gov/rsv/about/transmission.html'>http://www.cdc.gov/rsv/about/transmission.html</a></p>
                    </div>

                    <h1 className="text--subtitulo p-4">Evite el contacto con personas enfermas</h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls7Face.png" className='ps-2' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'>Si los padres o hermanos de un beb&eacute; susceptible se encuentran enfermos, deben usar tapabocas y evitar besar la cara y manos del ni&ntilde;o.<br /><br />Evite compartir utensilios como vasos o cubiertos con personas que tienen s&iacute;ntomas de resfr&iacute;o.</p>
                            </div>
                        </div>
                    </div>

                    <h1 className="text--subtitulo p-4">C&uacute;brase la nariz y la boca cuando tosa o estornude</h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls7CubrirBoca.png" className='ps-2' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'>Use la cara anterior del codo o un pa&ntilde;uelo desechable en vez de las manos.</p>
                            </div>
                        </div>
                    </div>

                    <h1 className="text--subtitulo p-4">Limpie y desinfecte las superficies</h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls7Desinfeccion.png" className='ps-2' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'>En especial, manijas de las puertas, juguetes, celulares y tabletas electr&oacute;nicas.</p>
                            </div>
                        </div>
                    </div>

                    <h1 className="text--subtitulo p-4">Qu&eacute;dese en casa si est&aacute; enfermo/a</h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls7Hogar.png" className='ps-2' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'>Esto proteger&aacute; a otros de ser contagiados.</p>
                            </div>
                        </div>
                    </div>

                    <h1 className="text--subtitulo p-4">Evite tocarse la cara sin haberse lavado las manos</h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls7LavarManos.png" className='ps-2' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'>En especial, evite tocarse los ojos y nariz sin haberse lavado las manos.</p>
                            </div>
                        </div>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>VSR: virus sincitial respiratorio. <br />
                            Adaptado de: <a className='texto--link' target='_blank' href='http://www.cdc.gov/rsv/about/transmission.html'>http://www.cdc.gov/rsv/about/transmission.html</a></p>
                    </div>

                </div>

                <div className="col-md-4 d-none d-sm-block d-sm-none d-md-block">
                    <img src="./img/Ls7Baby.gif" className='justify-content-start style--image-baby-7' />
                    {/* <img src="./img/Pose_1_compress.gif" className='justify-content-start' /> */}
                </div>
            </div>

            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                    <h1 className="text--subtitulo p-4">Vacunas e inmunizaci&oacute;n</h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls7Inyeccion.png" className='ps-2' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'>Actualmente existe un esquema de vacunaci&oacute;n que brinda nuestro Gobierno y que protege a los beb&eacute;s de los pat&oacute;genos m&aacute;s comunes y graves. <br /> <br />Tambi&eacute;n existe un esquema de <span className="texto--span">inmunizaci&oacute;n que reduce significativamente el riesgo de una infecci&oacute;n grave por VSR en beb&eacute;s prematuros</span> y que se encuentra incluido en el PBS.</p>
                            </div>
                        </div>
                    </div>

                    <div className='container'>
                        <div className='row d-flex ps-4 pt-4'>
                            <div className='col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex style--burbuja py-2 align-items-center'>
                                <div className='col-3 col-ms-3 col-md-2 col-lg-1 col-xl-1'>
                                    <img src="./img/Ls2IconEstetoscopio.png" className='' />
                                </div>
                                <div className='col-9 col-ms-9 col-md-9 col-lg-9 col-xl-11'>
                                <p className='texto--burbuja lh-1 ps-lg-3 ps-xl-5 m-0'>Pregunte a su m&eacute;dico/a sobre estos esquemas y mantenga a su beb&eacute; al d&iacute;a con el n&uacute;mero de dosis recomendado.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>PBS: Plan de Beneficios en Salud; VSR: virus sincitial respiratorio.<br />
                            Adaptado de: <a className='texto--link' target='_blank' href='https://www.healthychildren.org/English/safety-prevention/immunizations/Pages/Immunizations-For-Preterm-Babies.aspx'>https://www.healthychildren.org/English/safety-prevention/immunizations/Pages/Immunizations-For-Preterm-Babies.aspx</a></p>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default Ls7PrevencionVSR;